package horcrux.frontend.common.views.auth

import horcrux.common.api.dtos.types.EmailAddress
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.State
import horcrux.frontend.common.views.components.containers.ViewWithLogo
import js.objects.jso
import mui.material.Container
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.main
import web.cssom.pt

external interface AuthContainerProps : Props {
    var globalAppState: GlobalAppState
}

val AuthContainer = FC<AuthContainerProps> { props ->
    val authEnumState = State(AuthEnum.SIGN_UP)
    val authEnum = authEnumState.get()
    val emailAddressMaybeState = MaybeState<EmailAddress>()
    Container {
        this.component = main
        this.maxWidth = "xs"
        this.sx {
            this.margin = 5.pt
        }
        ViewWithLogo {
            this.globalAppState = props.globalAppState
            this.logoPropsMaybe = jso {
                this.widthMaybe = 200.0
            }

            AuthEnum.Selector {
                this.id = "auth-selector"
                this.currentSelection = authEnum
                this.onClick = { newAuthEnum, _ ->
                    authEnumState.set(newAuthEnum)
                }
                this.sx {
                    this.marginTop = 5.pt
                }
            }
            when (authEnum) {
                AuthEnum.SIGN_UP -> SignUp {
                    this.globalAppState = props.globalAppState
                    this.emailAddressMaybeState = emailAddressMaybeState
                    this.authEnumState = authEnumState
                }

                AuthEnum.SIGN_IN -> SignIn {
                    this.globalAppState = props.globalAppState
                    this.emailAddressMaybeState = emailAddressMaybeState
                }
            }
        }
    }
}
